import ComponentModule from "@eisinc/Overrides/Components/OrderUpload";

export * from "@eisinc/Overrides/Components/OrderUpload";

export default ComponentModule;
